import { DatiqCellActionType } from './datiq-cell-action.enum';
import { IDatiqCellAction } from './datiq-cell-action.interface';

export const emptyDatiqCellAction: IDatiqCellAction = {
    action: {
        name: 'No action',
    },
    type: DatiqCellActionType.Icon,
    disabled: false,
    icon: 'app:download',
};
